/**
 * A janela de impressão — ou "Salvar como PDF", que é a mesma janela.
 *
 * O documento leva o `styles.css` do produto, para o papel ter as mesmas fontes
 * e tokens da tela. Botões saem: no papel não se clica.
 */

const ENTIDADES: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function escaparHtml(texto: string): string {
    return texto.replace(/[&<>"']/g, (c) => ENTIDADES[c] ?? c);
}

export interface DocumentoParaImprimir {
    titulo: string;
    /** HTML do corpo, já escapado por quem monta. */
    corpo: string;
    /** CSS do documento, somado ao básico. */
    estilo?: string;
    paisagem?: boolean;
    /** Documento que já traz o próprio rodapé (a ficha impressa) dispensa o genérico. */
    rodape?: boolean;
}

/** `false` quando o navegador bloqueou a janela — quem chama avisa. */
export function abrirImpressao({ titulo, corpo, estilo = '', paisagem = false, rodape = true }: DocumentoParaImprimir): boolean {
    const w = window.open('', '_blank', 'width=900,height=720');
    if (!w) return false;

    w.document.write(
        `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="utf-8"><title>${escaparHtml(titulo)}</title>`
        + `<link rel="stylesheet" href="${new URL('/styles.css', location.href).href}">`
        + `<style>@page{size:A4${paisagem ? ' landscape' : ''};margin:16mm}`
        + 'body{background:#fff;padding:0;font-family:var(--font-ui);color:var(--text-primary)}'
        + 'button{display:none!important}'
        + 'footer{margin-top:18px;font-size:10px;color:var(--text-tertiary)}'
        + `${estilo}</style></head><body>`
        + corpo
        + (rodape ? `<footer>Fórmula MED · impresso em ${new Date().toLocaleString('pt-BR')}</footer>` : '')
        + '</body></html>',
    );
    w.document.close();
    window.setTimeout(() => { w.focus(); w.print(); }, 400);
    return true;
}
